import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a868c416"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ReviewAnswerViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16 ft18 boldFont"
}, "速记星超常儿童智力甄别和训练系统", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WatermarkerView = _resolveComponent("WatermarkerView");
  const _component_el_row = _resolveComponent("el-row");
  const _component_ReviewAnswerCard = _resolveComponent("ReviewAnswerCard");
  const _component_el_col = _resolveComponent("el-col");
  const _component_QuestionReviewRenderPage = _resolveComponent("QuestionReviewRenderPage");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_WatermarkerView), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "wd100 wbg flex items-center opd20 ptr",
    style: {
      "height": "60px"
    },
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/'))
  }, {
    default: _withCtx(() => [_hoisted_2, _hoisted_3]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt32",
    style: {
      "width": "1278px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      style: {
        "display": "flex"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_ReviewAnswerCard, {
        questions: $data.answerState,
        onGoto: $options.onGoto,
        "group-size": $options.ansTypeMap($data.subject),
        subject: $data.subject,
        showList: $options.ansModeMap() === 0,
        "cost-time": $data.costTimeInSeconds,
        roomId: $data.roomId,
        tplId: $data.tplId,
        examResult: $data.result
      }, null, 8, ["questions", "onGoto", "group-size", "subject", "showList", "cost-time", "roomId", "tplId", "examResult"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "pdl10"
    }, {
      default: _withCtx(() => [$data.result ? (_openBlock(), _createBlock(_component_QuestionReviewRenderPage, {
        key: 0,
        "jump-to-index": $data.jumpToIndex,
        "group-size": $options.ansTypeMap($data.subject),
        subject: $data.subject,
        data: $data.result
      }, null, 8, ["jump-to-index", "group-size", "subject", "data"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })])], 64);
}